<template>
  <div>
    <el-page-header @back="goBack" :content="ticket_title" />
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="'批量设置'"
    />
  </div>
</template>

<script>
import * as ticket from "@/api/product/ticket.js";
import * as userGroup from "@/api/product/user-group.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      userGroupList: [],
      ticket_id: this.$route.query.ticket_id,
      ticket_title: this.$route.query.ticket_title,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "门票",
        // 表格底部按钮
        btnBottom: true,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        selection: true,
        // 判断唯一
        onlyId: "group_id",
        // 单选高亮
        current: false,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "group_name",
            label: "分组名称",
            type: "input",
            hide: true
          },
          {
            prop: "market_price",
            label: "市场价格",
            show: "number",
            hide: true
          },
          {
            prop: "suggest_price",
            label: "指导价格",
            show: "number",
            hide: true
          },
          {
            prop: "purchase_price",
            label: "采购价格",
            show: "number",
            hide: true
          },
          {
            prop: "share_price",
            label: "分销价格",
            show: "number",
            hide: true
          },
          {
            prop: "back_cash",
            label: "销售奖金",
            show: "number",
            hide: true
          },
          {
            prop: "status",
            label: "状态",
            type: "radio",
            show: "select",
            default: 0,
            selectDataList: [
              {
                label: "启用",
                value: 0
              },
              {
                label: "停用",
                value: 1
              }
            ],
            hide: true
          }
        ],
        btnNavLeft: [
          {
            text: "批量设置",
            size: "mini",
            type: "success",
            click: () => {
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      tableData: [],
      formData: {},
      formDesc: {
        market_price: {
          label: "市场价格",
          type: "number",
          attrs: {
            min: 0,
            precision: 2,
            controls: false
          }
        },
        suggest_price: {
          label: "指导价格",
          type: "number",
          attrs: {
            min: 0,
            precision: 2,
            controls: false
          }
        },
        purchase_price: {
          label: "采购价格",
          type: "number",
          attrs: {
            min: 0,
            precision: 2,
            controls: false
          }
        },
        share_price: {
          label: "分销价格",
          type: "number",
          attrs: {
            min: 0,
            precision: 2,
            controls: false
          }
        },
        back_cash: {
          label: "销售奖金",
          type: "number",
          attrs: {
            min: 0,
            precision: 2,
            controls: false
          }
        },
        status: {
          label: "状态",
          type: "radio",
          default: 0,
          options: [
            {
              text: "启用",
              value: 0
            },
            {
              text: "停用",
              value: 1
            }
          ]
        }
      },
      rules: {},
      multiSelect: [],
      dialogFormVisible: false
    };
  },
  created() {
    this.getlist();
    // userGroup.deleteUserGroupAll.r().then(res => {
    //   this.userGroupList = res;
    //   this.dataFormat();
    // });
  },
  methods: {
    refreshBtn() {
      this.getlist();
    },
    handleSubmit(form) {
      let status = form.status;
      delete form.status;
      let postData = {
        ticket_id: this.$route.query.ticket_id,
        status: status,
        groups: []
      };
      if (this.multiSelect.length <= 0) {
        for (let index = 0; index < this.tableData.length; index++) {
          // const element = array[index];
          postData.groups.push({
            group_id: this.tableData[index].group_id,
            status: status,
            pricing: {
              ...form
            }
          });
          // group_id
        }
      } else {
        for (let index = 0; index < this.multiSelect.length; index++) {
          // const element = array[index];

          postData.groups.push({
            group_id: this.multiSelect[index].group_id,
            status: status,
            pricing: {
              ...form
            }
          });
          // group_id
        }
      }
      ticket.setTicketPricing.r(postData).then(res => {
        if (res) {
          this.$message.success("设置成功");
        }
        this.dialogFormVisible = false;
        this.refreshBtn();
      });
    },
    handleSuccess() {},
    // 多选
    handleSelectionChange(e) {
      this.multiSelect = e;
    },
    searchSubmit(e) {
      let postData = {
        ticket_id: this.$route.query.ticket_id,
        groups: []
      };
      for (let index = 0; index < e.length; index++) {
        let item = e[index];
        postData.groups.push({
          status: item.status,
          group_id: item.group_id,
          pricing: {
            market_price: item.market_price,
            suggest_price: item.suggest_price,
            purchase_price: item.purchase_price,
            share_price: item.share_price,
            back_cash: item.back_cash
          }
        });
      }
      ticket.setTicketPricing.r(postData).then(res => {
        if (res) {
          this.$message.success("设置成功");
        }
      });
    },
    getlist() {
      this.tableData = [];
      ticket.getTicketPricingList.r({ ticket_id: this.ticket_id }).then(res => {
        // pricing
        for (let index = 0; index < res.length; index++) {
          let data;
          // if (res[index].pricing.length < 0) {
          //   data = {
          //     market_price: "0.00",
          //     suggest_price: "0.00",
          //     purchase_price: "0.00",
          //     share_price: "0.00",
          //     back_cash: "0.00"
          //   };
          // } else {
          //   data = res[index].pricing
          // }
          this.tableData.push({
            group_name: res[index].group_name,
            status: res[index].status,
            group_id: res[index].group_id,
            ...res[index].pricing
          });
        }
      });
    },
    dataFormat() {
      this.tableData = [];
      let data = {
        status: 0,
        group_id: 2,
        market_price: "0.00",
        suggest_price: "0.00",
        purchase_price: "0.00",
        share_price: "0.00",
        back_cash: "0.00"
      };
      for (let index = 0; index < this.userGroupList.length; index++) {
        this.tableData.push({
          status: 0,
          group_id: 2,
          market_price: "0.00",
          suggest_price: "0.00",
          purchase_price: "0.00",
          share_price: "0.00",
          back_cash: "0.00"
        });
        this.tableData[index].group_id = this.userGroupList[index].value;
      }
      // this.tableData;
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
